import { useEffect, useState } from 'react';
import { axiosInstance } from '../helpers/axios';
import { INewsCard } from '../types/types';

export const useFetchNews = (page: number = 1, size: number = 10) => {
    const [news, setNews] = useState<INewsCard[] | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [totalCount, setTotalCount] = useState<number>();
    const newsUrl = `/v1/news/?page=${page}&size=${size}`;

    useEffect(() => {
        setIsLoading(true);
        axiosInstance
            .get(newsUrl)
            .then((response) => {
                setTotalCount(response.data.page_count);
                setNews(response.data.objects);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setIsLoading(false));
    }, []);

    return { isLoading, news, totalCount };
};
